import { api } from "./client";

export interface CancelledItem {
  id: number;
  bill_id: number;
  bill_name: string;
  bill_element_id: number;
  item_id: number;
  station_id: number;
  quantity: number;
  price: number;
  percent: number;
  total_sum: number;
  /** Кой е НАТИСНАЛ сторното. */
  cancelled_by_user_id: number;
  cancelled_at: string;
  reason: string | null;
  is_defective: boolean;
  order_time: string;
  /** Сервитьорът НА СМЕТКАТА — по него е групирането „по сервитьор". */
  waiter_id?: number | null;
  /** Оборотът на този сервитьор за периода — за „% от оборота му". */
  waiter_period_revenue?: string | number;
  /** Оборотът на ЦЕЛИЯ период — знаменателят на „% от брутото". */
  period_revenue?: string | number;
  /**
   * Редовете с еднакъв ключ са сторнирани ЗАЕДНО (едно натискане на
   * „Сторнирай всичко"): BE ги разпознава по идентичното време на
   * транзакцията. `batch_size` е колко реда има в тази партида.
   */
  batch_key?: string;
  batch_size?: number;
  /**
   * `true` — има ЗАПИСАН преход, извел реда от „незапочнато" преди сторното;
   * `false` — има одит, но редът не е тръгвал; `null`/липсва — за реда няма
   * нито един кухненски запис и НЕ бива да се брои като „преди кухня".
   */
  after_kitchen?: boolean | null;
}

export interface CancellationsFilters {
  bill_id?: number;
  user_ids?: number[];
  start_date?: string;
  end_date?: string;
  /** Филтърът „смяна" (`lib/reportShift.ts`); без него — всички смени. */
  shift?: number;
}

export const getCancellations = async (
  filters?: CancellationsFilters
): Promise<CancelledItem[]> => {
  const params = new URLSearchParams();

  if (filters?.bill_id) {
    params.append("bill_id", filters.bill_id.toString());
  }
  if (filters?.user_ids && filters.user_ids.length > 0) {
    filters.user_ids.forEach((userId) => {
      params.append("user_id", userId.toString());
    });
  }
  if (filters?.start_date) {
    params.append("start_date", filters.start_date);
  }
  if (filters?.end_date) {
    params.append("end_date", filters.end_date);
  }
  if (filters?.shift) {
    params.append("shift", String(filters.shift));
  }

  const queryString = params.toString();
  const url = queryString
    ? `/bills/cancellations?${queryString}`
    : "/bills/cancellations";

  const response = await api.get<CancelledItem[]>(url);
  return response.data;
};
